import { render, staticRenderFns } from "./PaymentMain.vue?vue&type=template&id=ab92871e&lang=pug&"
import script from "./PaymentMain.vue?vue&type=script&lang=js&"
export * from "./PaymentMain.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PaymentMain.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
})
